export const RECIPE_ADD = 'RECIPE_ADD';
export const RECIPE_DELETE = 'RECIPE_DELETE';
export const RECIPE_UPDATE = 'RECIPE_UPDATE';
export const RECIPE_UPDATE_NAME = 'RECIPE_UPDATE_NAME';
export const RECIPE_UPDATE_DIRECTIONS = 'RECIPE_UPDATE_DIRECTIONS';
export const RECIPE_UPDATE_INGREDIENTS = 'RECIPE_UPDATE_INGREDIENTS';
export const LIST_BUILD = 'LIST_BUILD';




/** WEBPACK FOOTER **
 ** ./app/constants/recipeTypes.js
 **/